<template>
  <div class="Vendors">
    <el-tabs v-model="active_name" type="card" @tab-click="handleClick">
      <el-tab-pane label="Product List" name="first">
        <VendorList v-if="active_name==='first'"></VendorList>
      </el-tab-pane>
      <el-tab-pane label="Create Vendor" name="second">
        <VendorCreate
            @back="onListTap"
            v-if="active_name==='second'"
            :rate="true"
            :video="true"
            vid="0"
            :back="true"></VendorCreate>
      </el-tab-pane>
      <el-tab-pane label="Manage Category" name="third">
        <VendorCategory v-if="active_name==='third'"></VendorCategory>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import VendorList from "@/components/Vendors/VendorList/VendorList";
  import VendorCreate from "@/components/Vendors/VendorCreate/VendorCreate";
  import VendorCategory from "@/components/Vendors/VendorCategory/VendorCategory";

  export default {
    props: {},
    components: {
      VendorList,
      VendorCreate,
      VendorCategory,
    },
    data: () => {
      return {
        active_name: 'first'
      }
    },
    methods: {
      onListTap() {
        this.active_name = 'first'
      },
      handleClick(tab) {
        this.active_name = tab.paneName
      }
    },
    beforeMount(){
      this.active_name = this.$route.params.target?this.$route.params.target:"first"
    },
  };

</script>
